<template>
  <el-container class="index-con">
    <el-aside>
      <leftnav :collapsed="collapsed"></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon @collapseChange="handleChange"></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import navcon from './navcon.vue'
import leftnav from './leftnav.vue'
export default {
    data() {
        return  {
            showclass: 'asideshow',
            collapsed: false
        }
    },
    components: {
        navcon,
        leftnav,
    },
    methods: {
        handleChange(prop) {
            this.collapsed = prop;
        }
    }
}
</script>

<style>
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
section.el-container {
    height: 100%;
}
.el-submenu__title i {
    margin-right: 5px;
}
.el-header {
    padding: 0;
}
</style>